export const logAppVersion = () => {
    console.info(`App version: ${process.env.COMMIT_HASH}`);
};
